/**
 * Base URL for the Node API (Express). In dev (CRA on port 3002), defaults to localhost:5001.
 * In production, set REACT_APP_API_URL at build time, e.g. https://api.kuzkohistory.com
 * (no trailing slash). Otherwise relative /api/... is used and must be proxied to Node.
 */
export function getApiBase() {
  const fromEnv = process.env.REACT_APP_API_URL;
  if (fromEnv && String(fromEnv).trim()) {
    return String(fromEnv).trim().replace(/\/$/, "");
  }
  if (
    typeof window !== "undefined" &&
    window.location.port === "3002"
  ) {
    return "http://localhost:5001";
  }
  return "";
}
